// extracted by mini-css-extract-plugin
export default {"categories-links":"jG0Ej_"};